<template>
  <div>
    <div class="about">
      <h1>关于我们</h1>
    </div>
    <div class="about-content">
      本系统由北京工业大学与北京金石祥科技有限公司联合研制。其中，北京工业大学创建于1960年，是一所以工为主，工、理、经、管、文、法、艺术、教育相结合的多科性市属重点大学，是国家“211工程”、国家一流学科建设高校。北京金石祥科技有限公司创立于2016年，是一家专门从事设计、开发、生产精密传感器、数据采集器、智能传感器终端等产品，并基于精密传感器的行业应用向下游客户提供软件与物联网服务的专业化技术企业。
    </div>
    <div class="projects">
      <h3>主要工程案例</h3>
    </div>
    <div class="project-images">
      <el-row :gutter="20">
        <el-col :span="12">
          <img width="50%" height="220px" :src="xinHuo1Img" />
          <img width="50%" height="220px" :src="xinHuo2Img" />
          <img width="100%" height="180px" :src="xinHuoImg" />
        </el-col>
        <el-col :span="12">
          <img width="100%" height="400px" :src="dongAoImg" />
        </el-col>
      </el-row>
      <el-row>
        <el-col class="sub-title" :span="12">京沈客专北京星火站深基坑远程实时监控</el-col>
        <el-col class="sub-title" :span="12">2022北京冬奥会崇礼赛区大型模型试验监控</el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <img width="100%" height="400px" :src="fuZhongXinImg" />
        </el-col>
        <el-col :span="12">
          <img width="100%" height="400px" :src="daXinImg" />
        </el-col>
      </el-row>
      <el-row>
        <el-col class="sub-title" :span="12">北京城市副中心站大型交通枢纽深大基坑监控</el-col>
        <el-col class="sub-title" :span="12">北京大兴新机场综合管廊基坑自动化监测</el-col>
      </el-row>
    </div>
    <div class="contacts">
      <h3>联系方式</h3>
    </div>
    <div class="contacts-content">
      Tel：13436582152<br /><br />
      E-mail：jinshilaser@tom.com<br /><br />
      Web：http://www.jslaser.com<br /><br />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dongAoImg: "./static/about/dong_ao.png",
      xinHuo1Img: "./static/about/xinhuo1.png",
      xinHuo2Img: "./static/about/xinhuo2.png",
      xinHuoImg: "./static/about/xinhuo.png",
      daXinImg: "./static/about/da_xing.png",
      fuZhongXinImg: "./static/about/fu_zhong_xin.png",
    };
  }
};
</script>
<style scoped>
.sub-title {
  text-align: center;
  color: rgb(37, 31, 132);
  font-weight: bold;
}
.projects {
  margin: 60px 100px 20px 100px;
}
.project-images {
  margin: 20px 100px;
}
.contacts {
  margin: 60px 100px 20px 100px;
}
.contacts-content {
  margin: 20px 100px;
  font-size: 20px;
  font-family: "STFangsong";
}
.about {
  text-align: center;
}
.about-content {
  font-size: 20px;
  font-family: "STFangsong";
  text-indent: 2em;
  line-height: 2rem;
  word-wrap: break-word;
  margin: 20px 100px;
}
.image {
  width: 50vh;
  height: 50vh;
  display: block;
}
</style>
